import Vue from 'vue';

/**
 * You can use a functional component to render the vnodes for that section of your template:
 *
 * ```xml
 * <some-component>
 *   <div slot-scope="{ vnodes }">
 *     <vnodes :vnodes="vnodes"/>
 *   </div>
 * </some-component>
 * ```
 *
 * 同时也支持传入一个 factory 函数，可以返回一个 vnode 或者一个 vnode 数组
 *
 * 在需要这个能力的地方
 *
 * ```
 * components: {
 *   Vnodes,
 * }
 * ```
 */

const VNodes = {
  functional: true,
  render: (h, ctx) => {
    var _ctx$props$factory, _ctx$props;
    if (!VNodeCtor) VNodeCtor = h('h1').constructor;
    const nodes = ctx.props.vnodes || ((_ctx$props$factory = (_ctx$props = ctx.props).factory) === null || _ctx$props$factory === void 0 ? void 0 : _ctx$props$factory.call(_ctx$props));
    if (nodes.constructor !== VNodeCtor && (!Array.isArray(nodes) || nodes.length > 1)) {
      return h('div', nodes);
    }
    return nodes;
  }
};
let VNodeCtor;
export { VNodes };